<template>
  <NxInput
    name="etapa"
    type="select"
    label="Etapa:"
    v-model="localValue"
    :option-groups="listOptions"
    placeholder="Selecione a Etapa"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'

export default {
  name: 'NxSelectQuadroColuna',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    boardId: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      listOptions: {},
      selected: null
    }
  },
  created () {
    this.onLoadBoardColumns()
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      if (newVal !== this.value) {
        this.$emit('update:value', newVal)
      }
    }
  },
  methods: {
    onLoadBoardColumns () {
      BoardColumnRepository.Search(this.boardId, 20, 0)
        .then(res => {
          let activeOptions = this.filterAndReduce(res, x => !x.inative)
          let filedOptions = this.filterAndReduce(res, x => x.inative)

          let options = []

          if (this.onlyActive) {
            options = {
              Ativas: activeOptions
            }
          } else {
            options = {
              Ativas: activeOptions,
              Inativas: filedOptions
            }
          }

          this.listOptions = options
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Etapas', 'Erro')
          console.error(err)
        })
    },
    filterAndReduce (res, condition) {
      return res.data.content
        .filter(x => x.id != null && condition(x))
        .reduce((acc, x) => {
          acc[x.id] = x.nome
          return acc
        }, {})
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectQuadroColuna.vue